import script from "./SlotSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./SlotSelection.vue?vue&type=script&setup=true&lang=js"

import "./SlotSelection.vue?vue&type=style&index=0&id=353328e3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-353328e3"]])

export default __exports__